module.exports = "<div class=\"container-fluid\">\n  <div class=\"row h-100\">\n    <app-unassigned-tests class=\"col-3 h-100 w-100\" [class.all-assigned]=\"\"></app-unassigned-tests>\n    <app-schedule class=\"col h-100\"></app-schedule>\n  </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/schedule-container/schedule-container.component.html
// module id = ./src/app/schedule-container/schedule-container.component.html
// module chunks = main